import AirDatepicker from 'air-datepicker';
import localeDe from 'air-datepicker/locale/de';
import localize from '../localize';
import tooltip from '../tooltip';
import validator from "validator";
import Choices from "choices.js";
import { PhoneNumberUtil } from 'google-libphonenumber';

(function () {
  'use strict';

  const appointmentFormElement = document.querySelector('.js-appointment-form');
  const appointmentCardLinks = Array.from(document.querySelectorAll('.js-appointment-card'));
  const appointmentButtons = Array.from(document.querySelectorAll('.js-appointment-form__button'));
  const damagetypeElement = document.querySelector('.js-appointment-form-damagetype');
  const dateElement = document.querySelector('.js-appointment-form-date');
  const progress = document.querySelector('.js-appointment-progress_progress');
  const progressStart = document.querySelector('.js-appointment-progress__start');
  const appointmentSteps = Array.from(document.querySelectorAll('.js-appointment-form__section'));
  const appointmentStepsAmount = appointmentSteps.length;
  const choicesField = document.querySelector('.js-insurance-search-field');
  const appointmentSubmit = document.querySelector('.js-appointment-submit');
  const replacementCarCard = document.querySelector('.js-replacement-car-card');
  let choicesElement = null;
  const phoneUtil = PhoneNumberUtil.getInstance();

  const DONE = 4;
  const OK = 200;

  let appointmentForm = {
    today: new Date(),
    holidays: [],
    selectedDate: null,
    progressWidth: 0,
    minHourMonday: 0,
    mondayWithMinHour: null,
    initialize: function () {
      if ('undefined' !== typeof holidays && holidays.length > 0) {
        for (var i = 0; i < holidays.length; i ++) {
          let holidayItem = [];
          holidayItem['date'] = new Date(holidays[i]['timestamp'] * 1000);
          holidayItem['label'] = holidays[i]['label'];
            appointmentForm.holidays.push(holidayItem);
        }
      }

      appointmentForm.progressWidth = 100 / appointmentSteps.length;

      let config = { attributes: true};
      const observer = new MutationObserver(appointmentForm.observationCallback);

      appointmentSteps.forEach(function(step) {
        observer.observe(step, config);
      });

      if (appointmentCardLinks) {
        appointmentCardLinks.forEach(function(card){
          card.addEventListener('click', function(event) {
            event.preventDefault();
            if (card.hasAttribute('data-target-sub-section')) {
              let subSection = document.querySelector('.' + card.getAttribute('data-target-sub-section'));
              if (subSection) {
                subSection.classList.add('visible');
                subSection.classList.add('js-visible');
                subSection.scrollIntoView();
                let focusElement = subSection.querySelector('.js-step-focus');
                if (focusElement) {
                  focusElement.focus({preventScroll:true});
                }
                appointmentForm.removeInertOnSubSectionOrSection(subSection);
              }
              card.classList.add('active');
              card.classList.add('js-active');
              appointmentForm.initCover('.' + card.getAttribute('data-target-cover'));
            }
            if (card.hasAttribute('data-target-select-value') && card.hasAttribute('data-target-select')) {
              let selectElement = document.querySelector('.' + card.getAttribute('data-target-select'));
              selectElement.value = card.getAttribute('data-target-select-value');
              card.classList.add('active');
              card.classList.add('js-active');
            }
          });
        });
      }

      if (appointmentButtons) {
        appointmentButtons.forEach(function(button){
          button.addEventListener('click', function(event) {
            event.preventDefault();
            let closestSection = this.closest('.js-appointment-form__section');
            if (closestSection) {
              let fieldsToValidate = Array.from(closestSection.querySelectorAll('.js-validate'));
              fieldsToValidate.forEach(function (field){
                field.addEventListener('keyup', function() {
                  appointmentForm.validateFormFields(closestSection);
                });
                field.addEventListener('blur', function() {
                  appointmentForm.validateFormFields(closestSection);
                });
              });
            }
            if (appointmentForm.validateFormFields(closestSection)) {
              if (button.hasAttribute('data-target-cover')) {
                appointmentForm.initCover('.' + button.getAttribute('data-target-cover'));
              }
              if (button.hasAttribute('data-target-section')) {
                let sectionIdentifier = button.getAttribute('data-target-section');
                let section = document.querySelector('.' + sectionIdentifier);
                section.classList.add('visible');
                section.classList.add('js-visible');
                section.scrollIntoView();
                let focusElement = section.querySelector('.js-step-focus');
                if (focusElement) {
                  focusElement.focus({preventScroll:true});
                }
                appointmentForm.removeInertOnSubSectionOrSection(section);
                if (choicesElement) {
                  choicesElement.disable();
                }

                switch (sectionIdentifier) {
                  case 'js-appointment-form__section--2':
                    appointmentForm.initSection2();
                    break;
                  case 'js-appointment-form__section--5':
                    appointmentForm.initSection5();
                    break;
                }
              }
            }
          });
        });
      }
      appointmentSubmit.addEventListener('click', function(e) {
        // Button might be triggered via datepicker, make sure it does only submit when in step 7
        e.preventDefault();
        if (document.querySelector('.js-appointment-form__section--7').classList.contains('js-visible')) {
          // Enable choices element or it might not send its data
          if (choicesElement) {
            choicesElement.enable();
          }
          appointmentFormElement.submit();
          this.setAttribute('disabled', 'disabled');
        }
      });

      if (choicesField) {
        choicesElement = new Choices(choicesField, {
          searchEnabled: true,
          addItems: false,
          searchFields: ['label'],
          itemSelectText: localize('js.choices.item_select_text'),
          noResultsText: localize('js.choices.no_results_text'),
          allowHTML: true,
        });
        if (choicesElement) {
          choicesElement.disable();
        }
      }
    },
    observationCallback: function(mutationList, observer) {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          let activeSteps = Array.from(document.querySelectorAll('.js-appointment-form__section.js-visible'));
          let percent = 100 / appointmentStepsAmount * activeSteps.length;
          progress.style.width = percent + '%';
          progressStart.innerHTML = Math.floor(percent) + '%';
        }
      }
    },
    initSection2: function () {
      // Init datepicker
      let minDiff = parseInt(appointmentFormSettings.forerunRepair);
      let maxHour = 16;

      // Manipulate the available dates depending on damage type and current weekday
      if (damagetypeElement.value !== 'repair-windscreen') {
        // Unhide replacement car option while were at it
        if (replacementCarCard) {
          replacementCarCard.classList.remove('visually-hidden');
        }

        minDiff = parseInt(appointmentFormSettings.forerunReplacement);
        maxHour = 12;

        switch (minDiff) {
          case 4:
            // On Tuesday after maxHour add 2 day
            if (appointmentForm.today.getDay() === 2 && appointmentForm.today.getHours() >= maxHour) {
              minDiff += 2;
            } else {
              if (appointmentForm.today.getDay() !== 6 &&
                appointmentForm.today.getDay() !== 0 &&
                appointmentForm.today.getHours() >= maxHour
              ) {
                minDiff += 1;
              }
            }
            if (appointmentForm.today.getDay() > 2) {
              minDiff += 1;
            }
            if (appointmentForm.today.getDay() === 6 || appointmentForm.today.getDay() === 0) {
              minDiff += 1;
            }
            break;
          case 6:
            // On Monday after maxHour add 2 day
            if (appointmentForm.today.getDay() === 1 && appointmentForm.today.getHours() >= maxHour) {
              minDiff += 2;
            } else {
              if (appointmentForm.today.getDay() !== 6 &&
                appointmentForm.today.getDay() !== 0 &&
                appointmentForm.today.getHours() >= maxHour
              ) {
                minDiff += 1;
              }
            }
            if (appointmentForm.today.getDay() > 1) {
              minDiff += 1;
            }
            if (appointmentForm.today.getDay() === 6 || appointmentForm.today.getDay() === 0) {
              minDiff += 1;
            }
            break;
          default:
            // On Friday after maxHour add 2 day
            if (appointmentForm.today.getDay() === 5) {
              minDiff += 2;
            } else {
              if (appointmentForm.today.getDay() !== 6 &&
                appointmentForm.today.getDay() !== 0 &&
                appointmentForm.today.getHours() >= maxHour
              ) {
                minDiff += 1;
              }
            }
            if (appointmentForm.today.getDay() === 6) {
              minDiff += 2;
            }
            if (appointmentForm.today.getDay() === 0) {
              minDiff += 1;
            }
        }
      } else {
        // Hide replacement car option while were at it
        if (replacementCarCard) {
          replacementCarCard.classList.add('visually-hidden');
          replacementCarCard.setAttribute('inert', 'inert');
        }

        // On Friday after Max Hour add 1 day
        if (appointmentForm.today.getDay() === 5 && appointmentForm.today.getHours() >= maxHour) {
          minDiff += 1;
          appointmentForm.minHourMonday = 12;
          appointmentForm.mondayWithMinHour = appointmentForm.today;
        } else {
          if (appointmentForm.today.getDay() !== 6 &&
            appointmentForm.today.getDay() !== 0 &&
            appointmentForm.today.getHours() >= maxHour
          ) {
            minDiff += 1;
          }
        }
        if (appointmentForm.today.getDay() === 6 || appointmentForm.today.getDay() === 0) {
          appointmentForm.minHourMonday = 12;
          appointmentForm.mondayWithMinHour = appointmentForm.today;
        }
      }

      let minDate = new Date(appointmentForm.today.getTime());

      minDate.setTime(minDate.getTime() + (minDiff * 86400000));

      // Prevent minDate on days where station is closed
      if (minDate.getDay() === 6 && appointmentFormSettings.stationIsClosedOnSaturday) {
        minDate.setTime(minDate.getTime() + 86400000);
      }

      if (minDate.getDay() === 0) {
        minDate.setTime(minDate.getTime() + 86400000);
      }

      for (let i = 0; i < appointmentForm.holidays.length; i ++) {
        if (
          minDate.getDate() === appointmentForm.holidays[i]['date'].getDate()
          && minDate.getMonth() === appointmentForm.holidays[i]['date'].getMonth()
          && minDate.getYear() === appointmentForm.holidays[i]['date'].getYear()
        ) {
          minDate.setTime(minDate.getTime() + 86400000);
        }
      }
      
      let dp = new AirDatepicker('#date', {
        locale: localeDe,
        minDate: minDate,
        onShow(isFinished) {
          // We need to set the element to readonly so the user cannot manipulate the date
          // This must happen dynamically or the datepicker cannot be triggered via keyboard navigation
          if (isFinished) {
            dateElement.setAttribute('readonly', 'readonly');
          }
        },
        onHide(isFinished) {
          // Make sure to remove the readonly attribute so validity can be checked properly
          if (isFinished) {
            dateElement.removeAttribute('readonly');
          }
        },
        onSelect({date, formattedDate, datepicker}) {
          if (date) {
            dateElement.removeAttribute('readonly');
            dp.hide();
            appointmentForm.initCover('.js-appointment-form__section--2__cover');
            appointmentForm.selectedDate = date;
            appointmentForm.initSection3();
          }
        },
        onRenderCell({date, cellType}) {
          if (cellType === 'day') {
            if (
              date.getDay() === 0
              || (date.getDay() === 6 && appointmentFormSettings.stationIsClosedOnSaturday)
            ) {
              return {
                disabled: true,
                classes: 'disabled-class',
                attrs: {}
              }
            }
          }
          for (let i = 0; i < appointmentForm.holidays.length; i ++) {
            if (
              date.getDate() === appointmentForm.holidays[i]['date'].getDate()
              && date.getMonth() === appointmentForm.holidays[i]['date'].getMonth()
              && date.getYear() === appointmentForm.holidays[i]['date'].getYear()
            ) {
              return {
                disabled: true,
                classes: 'disabled-class',
                attrs: {
                  title: appointmentForm.holidays[i]['label']
                }
              }
            }
          }
        }
      });
      dp.show();
    },
    initSection3: function() {
      let section = document.querySelector('.js-appointment-form__section--3');

      if (section) {
        section.classList.add('visible');
        section.classList.add('js-visible');
        section.scrollIntoView();
        let focusElement = section.querySelector('.js-step-focus');
        if (focusElement) {
          focusElement.focus({preventScroll:true});
        }

        let timeWrapper = document.querySelector('.js-time-cards');
        timeWrapper.innerHTML = '';

        let hourInterval = 0;
        let hourMin = 8;
        let hourMax = 14;
        let hourStep = 1;

        if (damagetypeElement.value === 'repair-windscreen') {
          hourInterval = 1;
          hourMax = 16;
          if (appointmentForm.selectedDate.getDay() === 6) {
            hourMax = 12;
            hourMin = 9;
          }
          if (appointmentForm.selectedDate.getDay() === 1 &&
            (
              appointmentForm.today.getDay() === 6 ||
              appointmentForm.today.getDay() === 0 ||
              (
                appointmentForm.today.getDay() === 5 && (
                  appointmentForm.today.getHours() > 14 ||
                  (appointmentForm.today.getHours() === 14 && appointmentForm.today.getMinutes() >= 1)
                )
              )
            )
          ) {
            let diffDays = Math.ceil((appointmentForm.selectedDate.getTime() -
              appointmentForm.today.getTime())/(24*3600*1000));

            if (diffDays < 4) {
              hourMin = 14;
            }
          }
        } else {
          hourStep = 1;
          if (appointmentForm.selectedDate.getDay() === 6) {
            hourMin = 9;
            hourMax = 11;
          } else {
            hourMax = 16;
          }
        }

        if (appointmentForm.selectedDate === appointmentForm.mondayWithMinHour &&
          appointmentForm.selectedDate.getDay() === 1 &&
          appointmentForm.minHourMonday > 0
        ) {
          hourMin = appointmentForm.minHourMonday;
        }

        let hourCurrent = hourMin;
        let timeslotValue = '';
        let firstElementClass = ' js-step-focus';

        while (hourCurrent <= hourMax) {
          if (hourInterval > 0) {
            timeslotValue = hourCurrent + '–' + (hourCurrent + hourInterval) + ' ' + localize('js.clock');
          } else {
            timeslotValue = hourCurrent + ' ' + localize('js.clock');
          }
          let checked = '';

          timeWrapper.innerHTML += '<a href="#" class="time-cards__card js-time-cards__card js-toggle-inert' + firstElementClass + '" ' +
            'data-time="' + hourCurrent + ' ' + localize('js.clock') + '" data-hour="' + hourCurrent + '">' +
            hourCurrent + ' ' + localize('js.clock') + '</a>';

          hourCurrent += hourStep;
          firstElementClass = '';
        }
        let timeCards = Array.from(document.querySelectorAll('.js-time-cards__card'));
        if (timeCards) {
          let focusElement = timeWrapper.querySelector('.js-step-focus');
          if (focusElement) {
            focusElement.focus({preventScroll:true});
          }
          timeCards.forEach(function(card){
            card.addEventListener('click', function(event) {
              event.preventDefault();
              document.querySelector('.js-appointment-form-time').value = this.getAttribute('data-time');

              appointmentForm.selectedDate.setHours(parseInt(this.getAttribute('data-hour')));

              document.querySelector('.js-appointment-form-date_and_time').value =
                appointmentForm.selectedDate.toLocaleString('de-DE');

              this.classList.add('active');
              this.classList.add('js-active');

              appointmentForm.initCover('.js-appointment-form__section--3__cover');
              let section4 = document.querySelector('.js-appointment-form__section--4');
              section4.classList.add('visible');
              section4.classList.add('js-visible');
              section4.scrollIntoView();
              let focusElement = section4.querySelector('.js-step-focus');
              if (focusElement) {
                focusElement.focus({preventScroll:true});
              }
              appointmentForm.removeInertOnSubSectionOrSection(section4);
            });
          });
        }
      }
    },
    initSection5: function() {
      if (choicesElement) {
        choicesElement.enable();
      }

      let licensePlateParts = Array.from(document.querySelectorAll('.js-licence-plate-parts__part'));
      let licensePlate = document.querySelector('.js-licence-plate');
      if (licensePlateParts) {
        licensePlateParts.forEach(function(part) {
          part.addEventListener('blur', function() {
            licensePlate.value = document.querySelector('.js-licence-plate-parts__part-1').value.toUpperCase() + '-' +
              document.querySelector('.js-licence-plate-parts__part-2').value.toUpperCase() + ' ' +
              document.querySelector('.js-licence-plate-parts__part-3').value.toUpperCase();
          });
        });
      }
      let tooltipTrigger = document.querySelector('.js-tooltip__trigger');
      tooltip(tooltipTrigger);

      let damagedateField = document.getElementById('damagedate');

      if (damagedateField) {
        let damagedp = new AirDatepicker('#damagedate', {
          locale: localeDe,
          maxDate: new Date(),
          onShow(isFinished) {
            // We need to set the element to readonly so the user cannot manipulate the date
            // This must happen dynamically or the datepicker cannot be triggered via keyboard navigation
            if (isFinished) {
              damagedateField.setAttribute('readonly', 'readonly');
            }
          },
          onHide(isFinished) {
            // Make sure to remove the readonly attribute so validity can be checked properly
            if (isFinished) {
              damagedateField.removeAttribute('readonly');
            }
          },
          onSelect({date, formattedDate, datepicker}) {
            damagedateField.removeAttribute('readonly');
            damagedp.hide();
            damagedateField.selectedDate = date;
            document.querySelector('.js-appointment-form__section--5 .js-appointment-form__button').focus({preventScroll:true});
          },
        });
      }
    },
    validateFormFields: function (section) {
      let allFieldsAreValid = true;

      if (section) {
        let fieldsToValidate = Array.from(section.querySelectorAll('.js-validate'));
        if (fieldsToValidate) {
          fieldsToValidate.forEach(function (field){
            let errorMessage = field.nextElementSibling;
            if (field.hasAttribute('data-invalid-feedback')) {
              let errorMessageWrapper =
                document.querySelector('.' + field.getAttribute('data-invalid-feedback'));
              if (errorMessageWrapper) {
                errorMessage = errorMessageWrapper.querySelector('.js-invalid-feedback');
              }
            }

            let fieldIsValid = field.checkValidity();

            if (fieldIsValid && field.classList.contains('js-validate-email')) {
              if (validator.isEmail(field.value, {allow_utf8_local_part: false}) === false) {
                fieldIsValid = false;
              }
            }

            if (fieldIsValid && field.classList.contains('js-validate-phone')) {
              let phoneNumber = phoneUtil.parse(field.value, 'DE');

              if (phoneNumber) {
                if (!phoneUtil.isValidNumber(phoneNumber)) {
                  fieldIsValid = false;
                }
              } else {
                fieldIsValid = false;
              }
            }

            if (!fieldIsValid) {
              if (!errorMessage) {
                field.classList.add('is-invalid');
                let errorMessage = document.createElement('div');
                errorMessage.classList.add('invalid-feedback');
                errorMessage.classList.add('js-invalid-feedback');
                errorMessage.innerText = localize('js.validation.' + field.getAttribute('id'));

                if (field.hasAttribute('data-invalid-feedback')) {
                  let errorMessageWrapper =
                    document.querySelector('.' + field.getAttribute('data-invalid-feedback'));

                  if (errorMessageWrapper) {
                    errorMessageWrapper.append(errorMessage);
                  }
                } else {
                  field.after(errorMessage);
                }
              }
              allFieldsAreValid = false;
            } else {
              if (errorMessage) {
                errorMessage.remove();
              }
              field.classList.remove('is-invalid');
            }
          });
        }

        let errorInfo = section.querySelector('.js-form-error-info');
        if (allFieldsAreValid) {
          if (errorInfo) {
            errorInfo.remove();
          }
        } else {
          if (!errorInfo) {
            let errorInfo = document.createElement('div');
            errorInfo.classList.add('form-error-info');
            errorInfo.classList.add('appointment-form__form-error-info');
            errorInfo.classList.add('js-form-error-info');
            errorInfo.innerHTML = '<p class="form-error-info__p">' +
              '<svg class="error-info__svg" aria-hidden="1"><use xlink:href="#exclamation-octagon-fill"></use></svg>' +
              localize('js.validation.info') +
              '</p>';

            let legend = section.querySelector('.js-appointment-form__legend');
            if (legend) {
              legend.after(errorInfo);
            }
          }
        }
      }

      return allFieldsAreValid;
    },
    removeInertOnSubSectionOrSection: function (subSection) {
      let elementsToInert = Array.from(subSection.querySelectorAll('.js-toggle-inert'));
      if (elementsToInert) {
        elementsToInert.forEach(function(element){
          if (element.classList.contains('visually-hidden') === false) {
            element.removeAttribute('inert');
          }
        });
      }
      // Choices field
      let choicesFieldInSection = subSection.querySelector('.js-insurance-search-field');
      if (choicesFieldInSection) {
        choicesElement.enable();
      }
    },
    addInertOnSubSectionOrSection: function (subSection) {
      let elementsToInert = Array.from(subSection.querySelectorAll('.js-toggle-inert'));
      if (elementsToInert) {
        elementsToInert.forEach(function(element){
          element.setAttribute('inert', 'inert');
        });
      }
      // Choices field
      let choicesFieldInSection = subSection.querySelector('.js-insurance-search-field');
      if (choicesFieldInSection) {
        choicesElement.disable();
      }
    },
    resetCoverForSectionIdenitifer: function (identifier) {
      let cover = document.querySelector('.js-appointment-form__section--' + identifier + '__cover');
      if (cover) {
        cover.classList.remove('visible');
        cover.classList.remove('js-visible');
      }
    },
    resetActiveElementsInSectionOrSubSection: function (section) {
      let activeElements = Array.from(section.querySelectorAll('.js-active'));
      if (activeElements) {
        activeElements.forEach(function(card){
          card.classList.remove('active');
          card.classList.remove('js-active');
        });
      }
    },
    resetSectionsAndSubSections: function (resetSubSectionsIdentifiers, resetAndHideSubSectionsIdentifiers, resetAndHideSectionsIdentifiers, resetSectionsIdentifiers) {
      if (resetSubSectionsIdentifiers) {
        let resetSubSectionsIdentifiersArray = resetSubSectionsIdentifiers.split(',');
        if (resetSubSectionsIdentifiersArray.length > 0) {
          resetSubSectionsIdentifiersArray.forEach(function(identifier){
            let subSection = document.querySelector('.js-appointment-form__section--' + identifier);
            if (subSection) {
              appointmentForm.removeInertOnSubSectionOrSection(subSection);
              appointmentForm.resetActiveElementsInSectionOrSubSection(subSection);
              appointmentForm.resetCoverForSectionIdenitifer(identifier);

              let focusElement = subSection.querySelector('.js-step-focus');
              if (focusElement) {
                focusElement.focus({preventScroll:true});
                let scrollElement = focusElement.closest('.js-step-scroll');
                if (scrollElement) {
                  scrollElement.scrollIntoView();
                }
              }
            }
          });
        }
      }
      if (resetAndHideSubSectionsIdentifiers) {
        let resetAndHideSubSectionsIdentifiersArray = resetAndHideSubSectionsIdentifiers.split(',');
        if (resetAndHideSubSectionsIdentifiersArray.length > 0) {
          resetAndHideSubSectionsIdentifiersArray.forEach(function(identifier){
            let subSection = document.querySelector('.js-appointment-form__section--' + identifier);
            if (subSection) {
              appointmentForm.resetActiveElementsInSectionOrSubSection(subSection);
              appointmentForm.resetCoverForSectionIdenitifer(identifier);

              subSection.classList.remove('visible');
              subSection.classList.remove('js-visible');
            }
          });
        }
      }
      if (resetAndHideSectionsIdentifiers) {
        let resetAndHideSectionsIdentifiersArray = resetAndHideSectionsIdentifiers.split(',');
        if (resetAndHideSectionsIdentifiersArray.length > 0) {
          resetAndHideSectionsIdentifiersArray.forEach(function(identifier){
            let section = document.querySelector('.js-appointment-form__section--' + identifier);
            if (section) {
              switch(identifier) {
                case '2':
                  dateElement.value = '';
                  break;
              }
              appointmentForm.resetCoverForSectionIdenitifer(identifier);
              section.classList.remove('visible');
              section.classList.remove('js-visible');

              appointmentForm.removeInertOnSubSectionOrSection(section);
              appointmentForm.resetActiveElementsInSectionOrSubSection(section);
              appointmentForm.resetCoverForSectionIdenitifer(identifier);
            }
          });
        }
      }
      if (resetSectionsIdentifiers) {
        let resetSectionsIdentifiersArray = resetSectionsIdentifiers.split(',');
        if (resetSectionsIdentifiersArray.length > 0) {
          resetSectionsIdentifiersArray.forEach(function(identifier){
            let section = document.querySelector('.js-appointment-form__section--' + identifier);
            if (section) {
              appointmentForm.removeInertOnSubSectionOrSection(section);
              appointmentForm.resetActiveElementsInSectionOrSubSection(section);
              appointmentForm.resetCoverForSectionIdenitifer(identifier);
            }

            let focusElement = section.querySelector('.js-step-focus');
            if (focusElement) {
              focusElement.focus({preventScroll:true});
              let scrollElement = focusElement.closest('.js-step-scroll');
              if (scrollElement) {
                scrollElement.scrollIntoView();
              }
            }
          });
        }
      }
    },
    initCover(coverIdentifier) {
      let coverElement = document.querySelector(coverIdentifier);
      if (coverElement) {
        coverElement.classList.add('visible');
        coverElement.classList.add('js-visible');

        let closestSubSection = coverElement.closest('.js-appointment-form__sub-section');

        if (closestSubSection) {
          appointmentForm.addInertOnSubSectionOrSection(closestSubSection);
        } else {
          let closestSection = coverElement.closest('.js-appointment-form__section');
          appointmentForm.addInertOnSubSectionOrSection(closestSection);

          let tooltipGroups = Array.from(closestSection.querySelectorAll('.js-form-group--has-tooltip'));
          if (tooltipGroups) {
            tooltipGroups.forEach(function(tooltipGroup){
              tooltipGroup.classList.remove('form-group--has-visible-tooltip');
            });
          }
        }

        let editButton = coverElement.querySelector('.js-form-button--edit');
        editButton.addEventListener('click', function(event) {
          event.preventDefault();

          appointmentForm.resetSectionsAndSubSections(
            this.getAttribute('data-reset-sub-sections'),
            this.getAttribute('data-reset-and-hide-sub-sections'),
            this.getAttribute('data-reset-and-hide-sections'),
            this.getAttribute('data-reset-sections')
          );

          if (this.hasAttribute('data-reset-select') && this.getAttribute('data-reset-select') !== '') {
            let selectToReset = document.querySelector('.' + this.getAttribute('data-reset-select'));
            if (selectToReset) {
              selectToReset.value = '';
            }
          }
        });
      }
    }
  };

  if (appointmentFormElement) {
    appointmentForm.initialize();
  }
})();
